import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { SiteContext } from "../context";

export default function Seo({ title, description, url, img }) {
  const { siteconfig } = useContext(SiteContext);

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property="og:type" content="Website" />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={siteconfig?.shopname} />

      {/* End Facebook tags */}
      {/* Twitter tags */}
      <meta name="twitter:creator" content="@NaijaGunners1" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:image" content={img} />
      <meta name="twitter:description" content={description} />
      {/* End Twitter tags */}

      <meta name="keywords" content={description} />
      <meta name="description" content={description} />
    </Helmet>
  );
}
